// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3HyfT","type":"styles_type__LSaTq","choices":"styles_choices__1OHnp"};